export default __webpack_public_path__ + "static/media/fixedWhite.cdaa4216.svg";